export const init_orders_location = "/orders";
export const url_orders_home = `${init_orders_location}/home`;
export const url_bill_of_materials = `${init_orders_location}/bill-of-materials`;
export const url_bom_products = `${init_orders_location}/bom-products`;
